import React, { Component } from 'react';
import Chart from "react-apexcharts";
import axios from 'axios'
import { Circles } from 'react-loader-spinner'
import ExcelExport from '../ExcelExport/ExcelExport';

export class LIOchart extends Component {
    constructor() {
        super()
        this.state = {
            data_record: [],
            isLoaded: false,
            filterSupplier: '',
            filterDateTo: '',
            filterDateFrom: '',
            suppliers: JSON.parse(localStorage.getItem('suppliers'))

        };
        this.componentDidMount = this.componentDidMount.bind(this)
        this.filterChange = this.filterChange.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    // Helper to add days and format YYYY-MM-DD
    addDaysFormatted(dateStr, days) {
        if (!dateStr) return ''
        const d = new Date(dateStr + 'T00:00:00')
        d.setDate(d.getDate() + days)
        return d.toISOString().split('T')[0]
    }

    filterChange(key, event) {
        console.log(key + " " + event.target.value)
        if (key == 'to') {
            this.setState({ filterDateTo: event.target.value })
        } else if (key == 'from') {
            // when from changes, if current 'to' is out of new allowed range, adjust it
            const newFrom = event.target.value
            const maxAllowedTo = this.addDaysFormatted(newFrom, 3) // 4-day range: from + 3 days
            this.setState((prevState) => {
                let newTo = prevState.filterDateTo
                if (newTo && newTo > maxAllowedTo) {
                    newTo = maxAllowedTo
                }
                return { filterDateFrom: newFrom, filterDateTo: newTo }
            })
        } else if (key == 'filterSupplier') {
            this.setState({ filterSupplier: event.target.value })
        }

    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const token = localStorage.getItem("authTokenLoop");
        const dataUrl = API_URL + "/Bi_dashboard_lio"

        axios({
            method: 'post',
            url: dataUrl,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + token,
            },
        }).then((response) => {
            if (response.data.success) {
                const reportData = response.data.data;
                console.log(reportData);
                this.setState({ data_record: reportData })
                this.updateLoader(true)
            } else {
                console.log("No data returned from API")
                this.updateLoader(true)
            }
        }).catch(function (error) {
            console.log(error);
        });

    }

    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    updateChart() {
        const newToDate = this.state.filterDateTo;
        const newFromDate = this.state.filterDateFrom;
        const filterSupplier = this.state.filterSupplier;

        // Validation: ensure range is <= 4 days
        if (newFromDate && newToDate) {
            const maxAllowedTo = this.addDaysFormatted(newFromDate, 3)
            if (newToDate > maxAllowedTo) {
                alert('Date range cannot exceed 4 days. Please select a To date within 4 days of From date.')
                return
            }
        }

        const formData = new FormData();
        formData.append('filter_date_from', newFromDate);
        formData.append('filter_date_to', newToDate);
        formData.append('supplier_id', filterSupplier);
        this.setState({ isLoaded: false })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();

        var currentDate = new Date();
        currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDateFrom = currentDate.toISOString().split('T')[0];

        currentDate = new Date();
        var formattedDateTo = currentDate.toISOString().split('T')[0];

        formData.append('filter_date_from', formattedDateFrom);
        formData.append('filter_date_to', formattedDateTo);
        formData.append('supplier_id', '7');
        this.setState({ filterDateFrom: formattedDateFrom })
        this.setState({ filterDateTo: formattedDateTo })
        this.setState({ filterSupplier: '7' })
        this.getData(formData);
    }

    render() {
        // Prepare export headers and data for Excel
        const exportHeaders = [
            { label: "Vehicle Number", key: "vehicle_no" },
            { label: "Geofence", key: "geofence_location" },
            { label: "In Time", key: "geofence_in_time" },
            { label: "Out Time (Gatepass print time)", key: "gate_pass_time" },
            { label: "TTA Time", key: "turnaround_time" },
            { label: "Shipment", key: "shipment_no" }
        ];
        const exportData = this.state.data_record.map(record => ({
            Vehicle: record?.vehicle_no,
            Geofence: record?.geofence_location,
            In: record?.geofence_in_time,
            Out: record?.gate_pass_time,
            TTAT: record?.turnaround_time,
            Shipment: record?.shipment_no,
        }));

        // compute max allowed 'to' date for the currently selected from date
        const maxToDate = this.state.filterDateFrom ? this.addDaysFormatted(this.state.filterDateFrom, 3) : ''

        return (
            <div className={`card col-12 m-5`} style={{ width: '95%' }}>
                <div className='card-header border-0 pt-5'>
                    <div className='row'>
                        <div className='col-10'>
                            <h3 className='card-title align-items-start flex-column'>
                                <span className='card-label fw-bold fs-3 mb-1'>
                                    Location In & Out Time
                                    <br /> <span style={{ color: '#A3A5A6' }}>{this.state.filterDateFrom} to {this.state.filterDateTo}</span>
                                </span>
                            </h3>
                        </div>
                        <div className='col-2 d-flex align-items-center justify-content-end gap-5'>
                            <button
                                type='button'
                                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'
                                style={{ width: '7vh' }}>
                                <i className='fas fa-filter mx-1'></i> Filter
                            </button>
                            <ExcelExport
                                data={exportData}
                                headers={exportHeaders}
                                fileName={`Location_In_Out_${this.state.filterDateFrom}_to_${this.state.filterDateTo}`}
                            />
                            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>
                                <div className='separator border-gray-200'></div>
                                <div className='px-7 py-5'>
                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter From Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateFrom}
                                                onChange={(event) => this.filterChange('from', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter To Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateTo}
                                                onChange={(event) => this.filterChange('to', event)}
                                                className='form-control' max={maxToDate} />
                                        </div>
                                    </div>

                                    {/* <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter Supplier:</label>
                                        <div>

                                            <select name='suppliers' id='suppliers' className='form-control'
                                                value={this.state.filterSupplier}
                                                onChange={(event) => this.filterChange('filterSupplier', event)}>
                                                {this.state.suppliers.map((supplier) => (
                                                    <option key={supplier.sup_id} value={supplier.sup_id}>
                                                        {supplier.sup_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div> */}

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div id='loader' className={this.state.isLoaded == true && 'd-none'} style={{ height: "50%", width: "50%" }}>
                        <Circles
                            height="100%"
                            width="40%"
                            color="#EA1C26"
                            ariaLabel="circles-loading"
                            wrapperStyle={{ padding: "15% 0", marginLeft: "16%" }}
                            wrapperClass=""
                            visible={true}
                        />
                    </div>

                    <div id='loader' className={!this.state.isLoaded && 'd-none'} style={{ height: "400px", overflow: "auto" }}>
                        <table className='table table-bordered' style={{ border: '1px solid black' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#DBDEE0' }}>
                                    <th style={{ border: '1px solid black', padding: '1%', textAlign: 'center' }}>Vehicle Number</th>
                                    <th style={{ border: '1px solid black', padding: '1%', textAlign: 'center' }}>Geofence</th>
                                    <th style={{ border: '1px solid black', padding: '1%' }}>In Time </th>
                                    <th style={{ border: '1px solid black', padding: '1%' }}>Out Time (Gatepass print time) </th>
                                    <th style={{ border: '1px solid black', padding: '1%' }}>TTA Time </th>
                                    <th style={{ border: '1px solid black', padding: '1%' }}>Shipment </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data_record.map((record,idx) => (
                                    <tr key={record.idx}>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record?.vehicle_no}</td>
                                        <td style={{ border: '1px solid black', padding: '1%', textAlign: 'center' }}>{record?.geofence_location}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record?.geofence_in_time}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record?.gate_pass_time}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record?.turnaround_time}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record?.shipment_no}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        )
    }
}
// 6c6d1a06d6eecaca2fb670453dd17afa756DA04C8B626CC4AEAC99F54A8BBA100C60399A